import {httpClient} from '@/main';
import PlanEditModel, {SolveModel, WarehouseDescription} from '@/models/PlanEditModel';

export const fetchData = (id: number) =>
    httpClient.get<PlanEditModel>('plan/getExtendedView', {
        params: {
            id,
        },
    });

export const fetchCopyData = (id: number) =>
    httpClient.post<PlanEditModel>('plan/copy', null, {
        params: {
            id,
        },
    });

export const fetchSolveRun = (idPlan: number) =>
    httpClient.post<SolveModel>('solve/run', null, {
        params: {
            idPlan,
        },
    });

export const fetchSolveCancel = (idPlan: number) =>
    httpClient.post<SolveModel>('solve/cancel', null, {
        params: {
            idPlan,
        },
    });

export const fetchSolveProgress = (idPlan: number) =>
    httpClient.get<SolveModel>('solve/progress', {
        params: {
            idPlan,
        },
    });

export const fetchWarehousePlywood = () => httpClient.get<WarehouseDescription[]>('warehousePlywood/getDescriptions');
export const fetchWarehouseVeneer = () => httpClient.get<WarehouseDescription[]>('warehouseVeneer/getDescriptions');
export const fetchApprove = (id: number) =>
    httpClient.get<PlanEditModel>('plan/Approve', {
        params: {
            id,
        },
        is400ErrorHandled: true,
    } as any);
export const fetchDisapprove = (id: number) =>
    httpClient.get<PlanEditModel>('plan/Disapprove', {
        params: {
            id,
        },
        is400ErrorHandled: true,
    } as any);
